module.exports = __webpack_public_path__ + "img/zone100400.35244327.png";